import { render, staticRenderFns } from "./TournamentSettings.vue?vue&type=template&id=bbeaf814&scoped=true"
import script from "./TournamentSettings.vue?vue&type=script&lang=js"
export * from "./TournamentSettings.vue?vue&type=script&lang=js"
import style0 from "./TournamentSettings.vue?vue&type=style&index=0&id=bbeaf814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbeaf814",
  null
  
)

export default component.exports